import { PreRegistrationInfoResponseDto } from "@/data/dto/pre-registration-info-response-dto";
import { PreRegistrationPatientInfoEntity } from "@/domain/entity/pre-regitration-patient-info-entity";
import { assertPreRegistrationInfoResponseDto } from "@/utils/validation";

export class PreRegistrationPatientInfoListMapper {
  static toEntity(dto: PreRegistrationInfoResponseDto[]): PreRegistrationPatientInfoEntity[] {
    // 배열의 각 요소를 개별적으로 검증
    if (!Array.isArray(dto)) {
      throw new Error(
        "[PreRegistrationPatientInfoListMapper] :: toEntity :: input must be an array"
      );
    }

    // 각 항목을 검증
    dto.forEach((item, index) => {
      try {
        assertPreRegistrationInfoResponseDto(item);
      } catch (error) {
        throw new Error(
          `[PreRegistrationPatientInfoListMapper] :: toEntity :: Validation failed at index ${index}: ${
            error instanceof Error ? error.message : String(error)
          }`
        );
      }
    });

    console.log("[PreRegistrationPatientInfoMapper] :: toEntity :: dto", dto);

    return dto.map((item) => {
      return {
        patient: {
          screeningId: item.patient.screeningId,
          fullName: item.patient.fullName,
          isDeactivated: item.patient.isDeactivated,
          lastName: item.patient.lastName,
          firstName: item.patient.firstName,
          birthDate: item.patient.birthDate,
          gender: item.patient.gender,
          memo: item.patient.memo,
        },
        guardian: {
          fullName: item.guardian.fullName,
          lastName: item.guardian.lastName,
          firstName: item.guardian.firstName,
          phone: item.guardian.phone,
          email: item.guardian.email,
          displayPhone: item.guardian.displayPhone,
        },
        uuid: item.uuid,
      };
    });
  }
}
